var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('common-table',{attrs:{"table-columns":_vm.tableColumns,"url":_vm.url,"operate":_vm.operate,"searchs":_vm.searchs,"form-fields":_vm.formFields,"permission":_vm.permission}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }